export interface ApiSuccess {
    [key: string]: string;
}

export interface ApiError {
    [key: string]: string[];
}

export interface Shop {
    code: string;
    nom: string;
    nom_long: string;
    responsable: string;
    adresse: string;
    code_postal: string;
    ville: string;
    telephone: string;
    fax: string;
    site: string;
}

export interface Department {
    code: string;
    nom: string;
    codeRegion: string;
    zone: object;
}

export interface Region {
    code: string;
    nom: string;
    zone: object;
}

export interface City {
    _score:	number;
    code: string;
    nom: string;
    libelle: string;
    codesPostaux: Array<string>;
    codeDepartement: string;
    codeRegion: string;
    departement: Department;
    region: Region;
    population: number;
    contour: object;
    surface: number;
    magasin: Shop;
}

export interface Concession {
    code: string;
    nom: string;
    nom_long: string;
    responsable: string;
    adresse: string;
    code_postal: string;
    ville: string;
    telephone: string;
    fax: string;
    site: string;
}

// Initialize variables for abort controllers
let storeLocatorAutocompleteController = null as AbortController | any;
let storeLocatorGeolocationController = null as AbortController | any;
// let storeLocatorStoreController = null as AbortController | any;
// let storeLocatorStoreFromBOController = null as AbortController | any;

const storeLocatorAutocomplete = async (q: string, shop_only = false): Promise<Array<City>> => {
    // Abort running request
    if (storeLocatorAutocompleteController) {
        storeLocatorAutocompleteController.abort('debounced');
    }
    storeLocatorAutocompleteController = new AbortController();

    // Run new request
    const response = await fetch(`/api/autocomplete/${encodeURIComponent(q)}/?shop_only=${shop_only}`, {
        method: 'GET',
        signal: storeLocatorAutocompleteController.signal,
    });

    const data = await response.json();

    if (data.length > 0) {
        return data;
    } else {
        throw new Error('No results found');
    }
};

export interface FlatEntry {
    item: City;
    cpIndex: number;
    zip: string;
}

const citiesFlatResults = (results: City[]): FlatEntry[] => {
    if (!Array.isArray(results)) {
        return [];
    }
    const list: FlatEntry[] = [];
    for (const item of results) {
        if (!Array.isArray(item.codesPostaux) || item.codesPostaux.length === 0) {
            continue;
        }
        for (let i = 0; i < item.codesPostaux.length; i++) {
            list.push({ item, cpIndex: i, zip: item.codesPostaux[i] });
        }
    }
    return list;
};


const storeLocatorGeolocation = async (lat: number, lon: number): Promise<City[]> => {
    // Abort running request
    if(storeLocatorGeolocationController) {
        storeLocatorGeolocationController.abort("debounced")
    }
    storeLocatorGeolocationController = new AbortController()

    // Run new request
    const response = await fetch(`/api/geolocation/?lat=${lat}&lng=${lon}`, {
        method: 'GET',
        signal: storeLocatorGeolocationController.signal,
    });

    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
        return data;
    } else {
        throw new Error("No results found");
    }
}

const storeLocatorStore = async (code: string, signal?: AbortSignal): Promise<any> => {
    // Abort running request
    // if(storeLocatorStoreController) {
    //     storeLocatorStoreController!.abort("debounced")
    // }
    // storeLocatorStoreController = new AbortController()

    // Run new request
    const response = await fetch(`/api/store/${encodeURIComponent(code)}/`, {
        method: 'GET',
        signal,
    });

    if (!response.ok) {
        throw new Error(`Store Locator request failed (${response.status})`);
    }

    const data = await response.json();

    if (data.length > 0) {
        return data;
    } else {
        throw new Error("No results found");
    }
}

const storeLocatorStoreFromBO = async (code: string, signal?: AbortSignal): Promise<any> => {
    // Run new request
    const response = await fetch( window.location.origin + `/api/shop/${encodeURIComponent(code)}/`, {
        method: 'GET',
        signal,
    });

    if (!response.ok) {
        throw new Error(`Shop request failed (${response.status})`);
    }

    const data = await response.json();

    if (data) {
        return data;
    } else {
        throw new Error("No results found");
    }
}

export {storeLocatorAutocomplete, storeLocatorGeolocation, storeLocatorStore, storeLocatorStoreFromBO, citiesFlatResults}
